export function getWeekNumber(d) {
    // Copy date so don't modify original
    d = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
    // Set to nearest Thursday: current date + 4 - current day number
    // Make Sunday's day number 7
    d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay()||7));
    // Get first day of year
    var yearStart = new Date(Date.UTC(d.getUTCFullYear(),0,1));
    // Calculate full weeks to nearest Thursday
    var weekNo = Math.ceil(( ( (d - yearStart) / 86400000) + 1)/7);
    // Return array of year and week number
    return [d.getUTCFullYear(), weekNo];
}

export const updateCompletedPuzzlesCookie = function(puzzleName){

	let playlist = {};

	//

	// if cookie exists, update and replace it
	const ppzPlaylist = window.$.cookie("ppzPlaylist");

	if(ppzPlaylist !== undefined){
		playlist = JSON.parse(ppzPlaylist);
	}

	//

	playlist[puzzleName] = true;
	playlist = JSON.stringify(playlist);

	window.$.cookie("ppzPlaylist", playlist);
}

export const isPuzzleWon = function(puzzleName){
	let isWon = false;

	// if cookie exists, update and replace it
	let ppzPlaylist = window.$.cookie("ppzPlaylist");

	if(ppzPlaylist !== undefined){
		ppzPlaylist = JSON.parse(ppzPlaylist);

		if(ppzPlaylist[puzzleName] === true){
			isWon = true;
		}
	}

	return isWon;
}

export const unlockPuzzlesSetCookies = function(dayToUnlock){
	let week = getWeekNumber(new Date());
	let cookieName = "ppzUnlockedPuzzles" + week[0] + week[1];
	let cookieContents = {};

	// if cookie exists, update and replace it
	const currentCookie = window.$.cookie(cookieName);

	if(currentCookie !== undefined){
		cookieContents = JSON.parse(currentCookie);
		console.log("cookieContents", cookieContents);
	}

	cookieContents[dayToUnlock] = true;
	cookieContents = JSON.stringify(cookieContents);

	window.$.cookie(cookieName, cookieContents);

}

export const numberWithCommas = function(num) {
	return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export const deepCopyFunction = (inObject) => {
	let outObject, value, key

	if (typeof inObject !== "object" || inObject === null) {
		return inObject // Return the value if inObject is not an object
	}

	// Create an array or object to hold the values
	outObject = Array.isArray(inObject) ? [] : {}

	for (key in inObject) {
		value = inObject[key]

		// Recursively (deep) copy for nested objects, including arrays
		outObject[key] = deepCopyFunction(value)
	}

	return outObject
}

export const detectDeviceType = () => {
	return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
    ? 'mobile'
    : 'desktop';
	//console.log(detectDeviceType()); // "Mobile" or "Desktop"
}

export const removeDuplicateCharacters = (string) => {
	return string
	  .split('')
	  .filter(function(item, pos, self) {
		return self.indexOf(item) == pos;
	  })
	  .join('');
  }

export const facebookShare = function(appId, shareImage, shareURL, shareMsg, shareRedirectURI){
	
	var url = "https://www.facebook.com/dialog/feed";
	url += "?app_id=" + appId;
	url += "&description=" + encodeURIComponent(shareMsg);
	url += "&picture=" + encodeURIComponent(shareImage);
	url += "&link=" + encodeURIComponent(shareURL);
	url += "&redirect_uri=" + encodeURIComponent(shareRedirectURI);
	url += "&display=popup";

	window.open(url, "_blank");

}

export const twitterShare = function(shareMsg, shareURL){

	var url = "https://twitter.com/intent/tweet";
	url += "?text=" + encodeURIComponent(shareMsg);
	url += "&url=" + encodeURIComponent(shareURL);

	window.open(url, "_blank");
}



// WEBPACK FOOTER //
// ./src/js/utils/utils.js